/**
 * Allows the prop to be optional (not present in props object
 * in other words) but doesn't allow it to have value undefined
 */
export function optionalOneOf(values = []) {
  return (props, name) => {
    const defined = name in props;
    const correct = values.includes(props[name]);

    return (!defined || (defined && correct)
            ? null
            : new Error(`Property ${name} must be one of ${JSON.stringify(values)} but is: ${props[name]}.`));
  };
}
